<template>
  <div class="xueWeiDetail">
    <el-row class="bread-nav contain">
      <img src alt />
      <el-breadcrumb separator-class="el-icon-d-arrow-right">
        <img
          src="../assets/img/love.png"
          alt
          class="fl"
          style="margin-right:6px"
        />
        <el-breadcrumb-item>当前位置 : 经络穴位</el-breadcrumb-item>
        <el-breadcrumb-item>
          <!-- <span @click="jingluolist()">{{meridiansName}}</span> -->
          <span>{{ meridiansName }}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="content-width">
      <el-row :gutter="22">
        <!-- 左侧部分 -->
        <el-col :span="18">
          <el-row>
            <el-col :span="16">
              <span class="large-title">{{ name }}({{ pinyin }})</span>
              <span class="browse-count">浏览量：{{ llCount }}</span>
            </el-col>
            <el-col :span="8" class="text-right btn-group">
              <el-button
                size="small"
                icon="el-icon-star-on"
                class="btn1"
                :class="isCollection ? 'red' : 'grey'"
                @click="collectPer()"
                >收藏</el-button
              >
              <el-button
                size="small"
                icon="el-icon-share"
                class="btn1 grey"
                @click="shareF()"
                >分享</el-button
              >
              <div>
                <share
                  :config="config1"
                  style="display:inline-block"
                  v-if="isShare"
                ></share>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="jiangshi">
              <span>归属经络：{{ meridiansName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">位于部位</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ position }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">穴名释义</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ shiyi }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">特异性</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ teyixing }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">标准定位</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ bzdw }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">取法</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ qufa }}</el-col>
          </el-row>
          <el-row>
            <img :src="$store.state.imgUrl+qufaImg" alt style="max-width:100%" />
            <div class="imgTip" v-if="qufaImg">图片仅供学习参考，侵权请联系下架</div>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">穴位解剖</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ xwjp }}</el-col>
            <img :src="$store.state.imgUrl+xwjpImg" alt style="max-width:100%"/>
            <div class="imgTip" v-if="xwjpImg">图片仅供学习参考，侵权请联系下架</div>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">刺灸法</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ cjf }}</el-col>
            <img :src="$store.state.imgUrl+cjfImg" alt style="max-width:100%"/>
            <div class="imgTip" v-if="cjfImg">图片仅供学习参考，侵权请联系下架</div>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">功用</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ gy }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-title">主治</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="r-intro">{{ zhuzhi }}</el-col>
          </el-row>
        </el-col>
        <!-- 右侧部分 -->
        <el-col :span="6" class="adv-wrap">
          <div
            class="common-img-outer setPositon listdetail-adver-outer-img"
            v-for="(item, index) in jingxueAdverList"
            :key="index"
          >
            <a :href="item.urlLink">
              <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
              <span class="adver-words-tip" v-if="item.urlImage">{{
                adverWordsTip
              }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "xueWeiDetail",
  data() {
    return {
      id: "",
      isCollection: false, //没有收藏
      position: "",
      name: "",
      pinyin: "",
      daihao: "",
      llCount: "",
      meridiansName: "",
      shiyi: "",
      teyixing: "",
      bzdw: "",
      qufa: "",
      qufaImg: "",
      xwjp: "",
      xwjpImg: '',
      gy: '',
      cjf: '',
      cjfImg: '',
      zhuzhi: ''
    };
  },
  methods: {
    // 收藏和取消收藏
    collectPer() {
      let that = this;
      if (that.isCollection) {
        //已经收藏了
        that.unCollect(that.id, 6);
      } else {
        //还没收藏呢
        that.collect(that.id, 6);
      }
    },
    //经络详情
    jingluolist() {
      let that = this;
      that.$router.push({
        path: "/JingLuoDetail",
        query: { id: that.$route.query.meridiansId }
      });
    },
    getDetail(id) {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let url = "/jlxw/acupoint/get";
      let parmas = {
        id: id,
        userId: that.userInfo.id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.position = arr.position;
            that.name = arr.name;
            that.pinyin = arr.pinyin;
            that.daihao = arr.daihao;
            that.llCount = arr.llCount;
            that.meridiansName = arr.meridiansName;
            that.shiyi = arr.shiyi;
            that.teyixing = arr.teyixing;
            that.bzdw = arr.bzdw;
            that.qufa = arr.qufa;
            that.qufaImg = arr.qufaImg;
            that.xwjp = arr.xwjp;
            that.xwjpImg = arr.xwjpImg;
            that.gy = arr.function;
            that.cjf = arr.cjf;
            that.cjfImg = arr.cjfImg;
            that.zhuzhi = arr.zhuzhi;



            that.isCollection = arr.isCollection == "1" ? true : false;
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
          that.$message("网络错误！");
        });
    }
  },
  created() {
    let that = this;
    that.getPositionAdver(5, 3);
    console.log(that.$route.query.id, "that.$route.query.id");
    if (!!that.$route.query.id) {
      that.id = that.$route.query.id;
      that.getDetail(that.id);
    }
  }
};
</script>

<style scoped>
.img-outer {
  width: 466px;
  height: 264px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.imgTip{
  font-size:12px;
  color: #bbb;
  margin: 10px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/xueWeiDetail.vue